import React from 'react';
import { useIntl } from 'react-intl';

import ListboxVirtualized from 'components/mui/Form/Autocomplete/components/ListboxVirtualized';
import AutocompleteMui from '@mui/material/Autocomplete';
import { TextField } from 'components/mui/Form/Autocomplete/components/styledComponents';

const AutocompleteVirtualizedBase = ({
  options,
  slots = {},
  slotProps = {},
  textFieldProps = {},
  ...otherAutocompleteProps
}) => {
  const intl = useIntl();
  return (
    <AutocompleteMui
      disableListWrap
      options={options}
      slots={{
        ...slots,
      }}
      slotProps={{
        ...slotProps,
        listbox: { component: ListboxVirtualized, ...(slotProps.listbox || {}) },
      }}
      renderOption={(props, option, state) => [props, option, state]}
      renderInput={(params) => {
        return <TextField {...params} {...textFieldProps} />;
      }}
      noOptionsText={intl.formatMessage({ id: 'options.noOptionsText', defaultMessage: 'No options' })}
      isOptionEqualToValue={(listOption, option) => (option ? listOption.value === option.value : false)}
      {...otherAutocompleteProps}
    />
  );
};

export default AutocompleteVirtualizedBase;
